import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { login02, logo } from "../../imagepath";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Eye, EyeOff } from "feather-icons-react/build/IconComponents";
import { useAuth } from "../../../contexts/AuthContext";
import { APP_NAME } from "../../../constants/constants";
import { getDefaultRouteForRole } from "../../ProtectedRoute";

// import ReactPasswordToggleIcon from 'react-password-toggle-icon';



const Login = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated, isLoading, error, clearError, user } = useAuth();

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  // Reset scroll position on mount (fixes iOS Safari white screen after logout)
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  // Redirect if already authenticated - to role-appropriate page
  useEffect(() => {
    if (isAuthenticated && user?.role) {
      const defaultRoute = getDefaultRouteForRole(user.role);
      navigate(defaultRoute);
    }
  }, [isAuthenticated, user, navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (error) {
      clearError();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.email || !formData.password) {
      return;
    }

    try {
      await login(formData.email, formData.password);
      // Navigation will happen automatically via useEffect when isAuthenticated becomes true
    } catch (err) {
      // Error is handled by the AuthContext
      console.error('Login failed:', err);
    }
  };


  // let inputRef = useRef();
  // const showIcon = () => <i className="feather feather-eye" aria-hidden="true">
  //   <FeatherIcon icon="eye" />
  // </i>;
  // const hideIcon = () => <i className="feather feather-eye-slash" aria-hidden="true">
  //   <FeatherIcon icon="eye-off" />
  // </i>
  return (
    <>

      {/* Main Wrapper */}
      <div className="main-wrapper login-body">
        <div className="container-fluid px-0">
          <div className="row">
            {/* Login logo */}
            <div className="col-lg-6 login-wrap">
              <div className="login-sec">
                <div className="log-img">
                  <img
                    className="img-fluid"
                    src={login02}
                    alt="#"
                  />
                </div>
              </div>
            </div>
            {/* /Login logo */}
            {/* Login Content */}
            <div className="col-lg-6 login-wrap-bg">
              <div className="login-wrapper">
                <div className="loginbox">
                  <div className="login-right">
                    <div className="login-right-wrap">
                      <div className="account-logo">
                        <Link to="/admin-dashboard" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                          <img src={logo} width="50" height="50" alt="" />
                          <span style={{ marginLeft: '15px', fontSize: '28px', fontWeight: '500', color: '#2e37a4' }}>{APP_NAME}</span>
                        </Link>
                      </div>
                      <h2>Вход</h2>
                      
                      {/* Error Message */}
                      {error && (
                        <div className="alert alert-danger" role="alert">
                          {error}
                        </div>
                      )}
                      
                      {/* Form */}
                      <form onSubmit={handleSubmit}>
                        <div className="form-group">
                          <label>
                            Имейл <span className="login-danger">*</span>
                          </label>
                          <input 
                            className="form-control" 
                            type="email" 
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            placeholder="example@mail.com"
                            required
                          />
                        </div>
                        <div className="form-group">
                          <label>
                            Парола <span className="login-danger">*</span>
                          </label>
                          <input
                            type={passwordVisible ? 'text' : 'password'}
                            className="form-control pass-input"
                            name="password"
                            value={formData.password}
                            onChange={handleInputChange}
                            placeholder="Въведете паролата си"
                            required
                          />
                          <span
                            className="toggle-password"
                            onClick={togglePasswordVisibility}
                          >
                            {passwordVisible ? <EyeOff className="react-feather-custom" /> : <Eye className="react-feather-custom" />}
                          </span>
                        </div>
                        <div className="forgotpass">
                          <Link to="/forgot-password">Забравена парола?</Link>
                        </div>
                        <div className="form-group login-btn">
                          <button
                            type="submit"
                            className="btn btn-primary btn-block"
                            disabled={isLoading || !formData.email || !formData.password}
                          >
                            {isLoading ? 'Влизане...' : 'Вход'}
                          </button>
                        </div>
                      </form>
                      {/* /Form */}
                      <div className="next-sign">
                        <p className="account-subtitle">
                          Нямате акаунт? <Link to="/register">Регистрация</Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Login Content */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
